import type {LabelSize} from '@cypro/engine/database/schema'
import {LABEL_SIZES} from './label-sizes'

// canvas pixels per design px; keeps the text sharp on 203/300 dpi thermal printers
const SCALE = 6
// Satoshi's variable font defaults to Black (900), the weight the PDF uses for bold runs
const BAND_FONT_FAMILY = 'PreparationLabelBand'

let fontReady: Promise<void> | null = null

async function registerBandFont() {
  const font = await new FontFace(BAND_FONT_FAMILY, 'url(/fonts/Satoshi-Variable.ttf)', {weight: '900'}).load()
  document.fonts.add(font)
}

function loadBandFont() {
  fontReady ??= registerBandFont()
  return fontReady
}

/**
 * Draws the vertical band text (reading bottom to top, starting near the bottom like the
 * Figma labels) as a PNG sized to the band, which the PDF places as a plain image.
 */
export async function renderBandTextPng(text: string, size: LabelSize) {
  await loadBandFont()

  // the band minus its divider line, the full label height (design px, 8 px = 1 mm)
  const {band, page} = LABEL_SIZES[size]
  const canvas = document.createElement('canvas')
  canvas.width = (band.width - band.line) * SCALE
  canvas.height = page.height * SCALE
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas 2D context is not available')

  const fontSize = band.fontSize * SCALE
  ctx.font = `900 ${fontSize}px ${BAND_FONT_FAMILY}`
  ctx.letterSpacing = `${band.letterSpacing * SCALE}px`
  ctx.fillStyle = '#000'
  ctx.textAlign = 'left'
  ctx.textBaseline = 'alphabetic'

  // after rotating -90°, glyphs extend left of the baseline: shift it right by half the cap
  // height so the capitals sit centred in the band
  const capHeight = ctx.measureText('H').actualBoundingBoxAscent
  ctx.translate(canvas.width / 2 + capHeight / 2, canvas.height - band.margin * SCALE)
  ctx.rotate(-Math.PI / 2)
  ctx.fillText(text, 0, 0)

  return canvas.toDataURL('image/png')
}
